import React from 'react';
import { createRoot } from 'react-dom/client';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import {
    Button, Col,
    Label, Input,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Card, CardHeader, CardTitle, CardBody, Progress
} from "reactstrap";


import * as commonFunc from 'scripts/common';

import CNavbar from 'components/CNavbar';

import Historical from "components/Historical";
import AGenerateModel from 'components/generic/AGenerateModel';

import moment from "moment";
import ToolbarDate from 'components/ToolbarDate';

import Mark from 'mark.js';

var modalRoot;

export default function WidgetListGeneric(props) {
    const { data, formManager, modelFctManager, accessList, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues } = formManager;

    const [shouldRender, setShouldRender] = React.useState(false);
    const [listStatus, setListStatus] = React.useState([]);
    const [curStatus, setCurStatus] = React.useState(0);
    const [dataRows, setDataRows] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);
    const [dataCount, setDataCount] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [maxPages, setMaxPages] = React.useState(1);
    const [dataStamp, setDataStamp] = React.useState(0);
    const [curFilter, setCurFilter] = React.useState({});
    const [dtModel, setDtModel] = React.useState();

    const [curDate, setCurDate] = React.useState(data.argumentsObj?.cStartDate || moment().format());
    const [curPeriod, setCurPeriod] = React.useState(data.argumentsObj?.cStartPeriod || "L");

    const widgetRef = React.createRef();
    const modalGenManager = React.createRef();

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        loadStatusBtnGrp();
        //getListData();

        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
            if (data.argumentsObj.sidebarLocked) document.body.classList.remove("sidebar-locked");
        }
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    React.useEffect(() => {
        console.debug(data);
        if (data.defaultValue) {
            if (systemItem["@@URL_GETLIST@@"] && !(systemItem["@@URL_GETLIST@@"].argumentsObj && systemItem["@@URL_GETLIST@@"].argumentsObj.cPreventStartLoad)) {
                getListData();
            }
        }
        else {
            setDataRows([]);
            setFilteredRows([]);
            setDataStamp(0);
            if (!dtModel) getModel();
        }
    }, [data]);


    React.useEffect(() => {
        if (dataStamp > 0) getListData();
    }, [curStatus]);

    React.useEffect(() => {
        if (dataStamp > 0) getListData();
    }, [curDate]);

    React.useEffect(() => {
        if (dataStamp > 0) getListData(true);
    }, [currentPage]);


    React.useEffect(() => {
        var searchTag = "";
        var markClass = "";
        if (data.argumentsObj.cSearchParams) {
            searchTag = getValues(commonFunc.camelize(data.argumentsObj.cSearchParams, true)) || "";
            markClass = data.argumentsObj.cMarkClass || "fw-bold";

            if (widgetRef.current) {
                var targets = widgetRef.current.getElementsByClassName("searchParams");
                if (!commonFunc.isBlank(searchTag) && targets.length) {
                    Array.from(targets).forEach((elemNode, index) => {
                        var markChild = elemNode.getElementsByTagName("mark");
                        if (markChild.length <= 0) {
                            const instance = new Mark(elemNode);
                            instance.mark(searchTag, { className: markClass });
                            instance.mark(searchTag.replace("*", ""), { className: markClass });
                        }
                    });
                }
            }
        }
    }, [dataStamp]);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.clearModal = () => {
        return new Promise((resolve, reject) => {
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }

            resolve({ isSuccess: true, result: true });
        });
    };
    data.functionManager.getGetListCpt = () => { return systemItem["@@URL_GETLIST@@"]; };
    data.functionManager.refreshList = () => { getListData(); };
    data.functionManager.updateDataStamp = (datetime) => { setDataStamp(datetime || new Date().getTime()); };


    register(bindPropResult);

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));


    var systemItem = accessList;//modelFctManager.onActionRequired(data.name, { trigger: "findFragment", target: data.src } , data).then(actionResponse => {
    //Info : data.subType echo à systemItem["@@SECONDARY_KEY@@"].subType

    var primaryKey = commonFunc.camelize(systemItem["@@PRIMARY_KEY@@"].value);
    var secondaryKey = commonFunc.camelize(systemItem["@@SECONDARY_KEY@@"].value);

    function getModel() {
        if (data.argumentsObj.dtConfig) {
            modelFctManager.onActionRequired(data.name, { trigger: "getModel", value: data.argumentsObj.dtConfig }, data).then(actionResponse => {
                if (actionResponse.isSuccess) {
                    setDtModel(actionResponse.result);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: actionResponse.errorMessage
                    });
                }
            });
        }
    }

    function getListData(noResetPage) {
        if (!noResetPage && currentPage !== 1) {
            setCurrentPage(1);
            return;
        }
        //return;//TEMP
        setDataRows([]);
        setFilteredRows([]);
        setDataStamp(0);

        Swal.fire({
            title: t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        if (!dtModel) getModel();

        var args = {};
        var getlistItem = systemItem["@@URL_GETLIST@@"];
        if (getlistItem && getlistItem.argumentsObj && Object.keys(getlistItem.argumentsObj).length) {
            Object.keys(getlistItem.argumentsObj).forEach((key) => {
                var valueArgs = getlistItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else if (valueArgs === "currentPage") args[key] = currentPage;
                else if (key === "page") args[key] = currentPage;//TEMP - PATCH
                else args[key] = valueArgs;

                //Récup du statut par défaut (soit valeur defaultArgs, soit celle en state)
                if (valueArgs === "curStatus") {
                    var defaultStatus = curStatus;
                    var getstatusItem = systemItem["@@URL_GETSTATUS@@"];
                    if (!defaultStatus && getstatusItem && getstatusItem.argumentsObj && Object.keys(getstatusItem.argumentsObj).length) {
                        defaultStatus = getstatusItem.argumentsObj["defaultStatus"]
                    }
                    args[key] = defaultStatus;
                }
            });
            if (args.filters && (args.filterInput != null && args.filterInput !== undefined)) {
                if (!commonFunc.isBlank(args.filterInput)) {
                    args.filters = [...args.filters];
                    args.filters.push(args.filterInput);
                }
                delete args.filterInput;
            }

            var useDate = getlistItem.argumentsObj.cUseToolbarDate;
            if (useDate) {
                args.startDate = curDate;
                args.period = curPeriod;
            }

            var callbackResponse = (srcElem) => {
                if (srcElem && srcElem.length && srcElem[0].extras) {
                    srcElem.forEach((row) => {
                        row.orgExtras = row.extras;
                        row.extras = {};
                        if (row.orgExtras && row.orgExtras.length) {
                            row.orgExtras.forEach((extra) => {
                                row.extras[extra.name] = extra.value;
                            });
                        }
                    });
                }
                if (srcElem && srcElem.length && srcElem[0].hasOwnProperty("custom")) {
                    srcElem.forEach((row) => {
                        if (row.custom) {
                            row.custom.orgExtras = row.custom.extras;
                            row.custom.extras = {};
                            if (row.custom.orgExtras && row.custom.orgExtras.length) {
                                row.custom.orgExtras.forEach((extra) => {
                                    row.custom.extras[extra.name] = extra.value;
                                });
                            }
                        }
                    });
                }
                Swal.close();
                setDataRows(srcElem);
                setFilteredRows(filterData(curFilter, srcElem));
                setDataStamp(new Date().getTime());

                //ScrollTo Top
                if (modelFctManager.appProps?.getScrollerContainer().scrollTop > 300) {
                    //var element = document.querySelector('.widget-container');
                    modelFctManager.appProps?.getScroller()?.smoothScroll(0, 1000);//element.offsetTop
                }
            };

            if (getlistItem.argumentsObj.useProp) {
                var list = [];
                var valueArgs = getlistItem.argumentsObj.useProp;
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) list = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else list = valueArgs;
                callbackResponse(list);
            }
            else {
                var url = "../" + getlistItem.argumentsObj.url;

                var callMethod = commonFunc.getMethod;
                if (getlistItem.argumentsObj.cMethod === "POST") callMethod = commonFunc.postMethod;

                callMethod(url, args).then((response) => {

                    if (response.data) {
                        if (response.data.isSuccess) {
                            if (response.data.extraInfo && response.data.extraInfo.isSuccess) {

                                //response.data.extraInfo.count
                                //response.data.extraInfo.extraInfo.maxPages
                                setDataCount(response.data.extraInfo.count);
                                setMaxPages(response.data.extraInfo.extraInfo?.maxPages || 1);

                                callbackResponse(response.data.extraInfo.result);
                            }
                            else if (Array.isArray(response.data.result)) {
                                callbackResponse(response.data.result);
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    didOpen: () => { Swal.hideLoading() },
                                    html: t(data.subType + "_errorGetlist") + " :<br>" + response.data.errorMessage
                                });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                didOpen: () => { Swal.hideLoading() },
                                html: t(data.subType + "_errorGetlist") + " :<br>" + response.data.errorMessage
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(data.subType + "_errorGetlist")
                        });
                    }
                });
            }
        }
        else {
            if (!getlistItem) {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_errorCfg")
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    function filterData(localFilter, rows) {
        if (!rows) rows = dataRows;

        var filteredRows = rows.filter((row) => {
            var flag = true;
            Object.keys(localFilter).forEach((key) => {
                var filterValue = localFilter[key];
                flag = (commonFunc.isBlank(filterValue) || commonFunc.getValue(row, key) === filterValue);
            });
            return flag;
        });

        return filteredRows/*.sort((row) => row.score)*/;//TEMP
    }

    function saveList() {
        var saveItem = systemItem["@@URL_SAVELIST@@"];
        var saveProcess = function () {
            Swal.fire({
                title: t("gal_saving"),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            var args = {};
            if (saveItem && saveItem.argumentsObj && Object.keys(saveItem.argumentsObj).length) {
                var dataList = [];//TODO : getSelected widgets

                var postData = dataList.data;
                if (!commonFunc.isBlank(saveItem.subType)) {
                    switch (saveItem.subType) {
                        case "keyItem":
                            var valueKeyItem = saveItem.argumentsObj.cMapItem?.valueKey;
                            var tagKeyItem = saveItem.argumentsObj.cMapItem?.tagKey;
                            postData = dataList.data.map((row, index) => { return { id: row[dataList.rowId], value: row[valueKeyItem] || "", tag: row[tagKeyItem] || "" } });
                            break;
                        default: break;
                    }
                }

                Object.keys(saveItem.argumentsObj).forEach((key) => {
                    var valueArgs = saveItem.argumentsObj[key];
                    if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                    else args[key] = valueArgs;
                    if (valueArgs === "listValues") args[key] = postData;
                });

                var url = "../" + saveItem.argumentsObj.url;

                console.debug(args);
                //return;//TEMP
                commonFunc.postMethod(url, args).then((response) => {
                    var dataSave = response.data;
                    if (dataSave) {
                        if (dataSave.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: (t(data.subType + "_success") === (data.subType + "_success") ? t("gal_success") : t(data.subType + "_success")),
                                html: (t(data.subType + "_successUpd") === (data.subType + "_successUpd") ? t("gal_successUpd") : t(data.subType + "_successUpd")),
                                didOpen: () => { Swal.hideLoading() },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                getListData();
                            });

                        }
                        else {
                            var supErrors = "";
                            if (dataSave.errors && dataSave.errors.length) {
                                supErrors = dataSave.errors.map((error) => {
                                    return "<br>" + error.desc + "(" + error.value + ")";
                                });
                            }
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorUpd") + " :<br>" + dataSave.errorMessage + supErrors,
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorUpd"),
                            didOpen: () => { Swal.hideLoading() },
                        });
                    }
                });
            }
            else {
                if (!saveItem) {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_errorCfg"),
                        didOpen: () => { Swal.hideLoading() },
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_invalidArgs")
                    });
                }
            }
        };

        if (saveItem && saveItem.argumentsObj && saveItem.argumentsObj.unconfirmProcess) {
            saveProcess();
        }
        else {
            Swal.fire({
                icon: "question",
                title: t(data.subType + "_updListTitle"),
                html: t(data.subType + "_updListTitle2"),
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: t("gal_yes"),
                cancelButtonText: t("gal_no"),
            }).then((result) => {
                if (result.value) {
                    saveProcess();
                }
            });
        }
    }

    function removeList() {
        var removeItem = systemItem["@@URL_REMOVELIST@@"];
        var removeProcess = function () {
            Swal.fire({
                title: t("gal_removing"),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            var args = {};
            if (removeItem && removeItem.argumentsObj && Object.keys(removeItem.argumentsObj).length) {
                var dataList = [];//TODO : getSelected widgets

                var postData = dataList.data;
                if (!commonFunc.isBlank(removeItem.subType)) {
                    switch (removeItem.subType) {
                        case "keyItem":
                            postData = dataList.data.map((row, index) => { return { id: row[dataList.rowId], value: "", tag: "" } });
                            break;
                        default: break;
                    }
                }

                Object.keys(removeItem.argumentsObj).forEach((key) => {
                    var valueArgs = removeItem.argumentsObj[key];
                    if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                    else args[key] = valueArgs;
                    if (valueArgs === "listValues") args[key] = postData;
                });

                var url = "../" + removeItem.argumentsObj.url;

                console.debug(args);
                //return;//TEMP
                commonFunc.postMethod(url, args).then((response) => {
                    var dataSave = response.data;
                    if (dataSave) {
                        if (dataSave.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: (t(data.subType + "_success") === (data.subType + "_success") ? t("gal_success") : t(data.subType + "_success")),
                                html: (t(data.subType + "_successRmv") === (data.subType + "_successRmv") ? t("gal_successRmv") : t(data.subType + "_successRmv")),
                                didOpen: () => { Swal.hideLoading() },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                getListData();
                            });

                        }
                        else {
                            var supErrors = "";
                            if (dataSave.errors && dataSave.errors.length) {
                                supErrors = dataSave.errors.map((error) => {
                                    return "<br>" + error.desc + "(" + error.value + ")";
                                });
                            }
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorRmv") + " :<br>" + dataSave.errorMessage + supErrors,
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorRmv"),
                            didOpen: () => { Swal.hideLoading() },
                        });
                    }
                });
            }
            else {
                if (!removeItem) {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_errorCfg"),
                        didOpen: () => { Swal.hideLoading() },
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_invalidArgs")
                    });
                }
            }
        };

        if (removeItem && removeItem.argumentsObj && removeItem.argumentsObj.unconfirmProcess) {
            removeProcess();
        }
        else {
            Swal.fire({
                icon: "question",
                title: t("gal_rmvTitle"),
                html: t(data.subType + "_rmvListTitle"),
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: t("gal_yes"),
                cancelButtonText: t("gal_no"),
            }).then((result) => {
                if (result.value) {
                    removeProcess();
                }
            });
        }
    }
    function loadStatusBtnGrp() {
        setListStatus([]);

        Swal.fire({
            title: t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        var getstatusItem = systemItem["@@URL_GETSTATUS@@"];
        if (getstatusItem && getstatusItem.argumentsObj && Object.keys(getstatusItem.argumentsObj).length) {
            Object.keys(getstatusItem.argumentsObj).forEach((key) => {
                var valueArgs = getstatusItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + getstatusItem.argumentsObj.url;
            commonFunc.getMethod(url, args).then((response) => {

                if (response.data) {
                    if (response.data.isSuccess) {

                        Swal.close();
                        setListStatus(response.data.result);
                        setCurStatus(getstatusItem.argumentsObj.defaultStatus);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(data.subType + "_errorGetstatus") + " :<br>" + response.data.errorMessage
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t(data.subType + "_errorGetstatus")
                    });
                }
            });
        }
        else {
            if (!getstatusItem) {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_errorCfg")
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    function getData(idElem) {
        return new Promise((resolve, reject) => {
            var id = idElem;
            if (id > 0) {
                Swal.fire({
                    title: t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                var args = {};
                var getItem = systemItem["@@URL_GET@@"];
                if (getItem && getItem.argumentsObj && Object.keys(getItem.argumentsObj).length) {
                    Object.keys(getItem.argumentsObj).forEach((key) => {
                        var valueArgs = getItem.argumentsObj[key];
                        if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                        else args[key] = valueArgs;
                    });

                    var url = "../" + getItem.argumentsObj.url;
                    commonFunc.getMethod(url, args).then((response) => {

                        if (response.data) {
                            if (response.data.isSuccess) {

                                Swal.close();

                                resolve(response.data);
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    didOpen: () => { Swal.hideLoading() },
                                    html: t(data.subType + "_errorGet") + " :<br>" + response.data.errorMessage
                                });
                                resolve({ isSuccess: false, result: (t(data.subType + "_errorGet") + " :<br>" + response.data.errorMessage) });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                didOpen: () => { Swal.hideLoading() },
                                html: t(data.subType + "_errorGet")
                            });
                            resolve({ isSuccess: false, result: t(data.subType + "_errorGet") });
                        }
                    });
                }
                else {
                    if (!getItem) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t("gal_errorCfg")
                        });
                        resolve({ isSuccess: false, result: t("gal_errorCfg") });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t("gal_invalidArgs")
                        });
                        resolve({ isSuccess: false, result: t("gal_invalidArgs") });
                    }
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidID")
                });
                resolve({ isSuccess: false, result: t("gal_invalidID") });
            }
        });
    }

    function saveData(idElem, rowData, forcedCreate) {
        if (disabled) return;
        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        var currData = rowData;


        //Traitement des informations retourné par le Dialog
        var callbackModal = function (dataElem, isUpdate) {
            return new Promise((resolve, reject) => {
                if (dataElem) {
                    Swal.fire({
                        title: t("gal_saving"),
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    dataElem[secondaryKey] = isUpdate ? currData[secondaryKey] : 0;

                    var saveItem = isUpdate ? systemItem["@@URL_UPD@@"] : (systemItem["@@URL_ADDSUP@@"] || systemItem["@@URL_ADD@@"]);
                    if (saveItem && saveItem.argumentsObj && Object.keys(saveItem.argumentsObj).length) {
                        var url = "../" + saveItem.argumentsObj.url;

                        if (!dataElem.avoidMerge) {
                            if (currData && currData.hasOwnProperty("custom")) {
                                dataElem = commonFunc.mergeDeep({}, currData.custom, dataElem);
                                dataElem.idEntity = currData.custom ? currData.custom.idEntity : 0;
                            }
                            else {
                                dataElem = commonFunc.mergeDeep({}, currData, dataElem);
                            }

                            dataElem.status = null;
                            dataElem.category = null;
                            dataElem.custom = null;
                            dataElem.parent = null;
                            dataElem.site = null;
                            dataElem.extraSite = null;
                            dataElem.client = null;
                            dataElem.material = null;//Patch Upd Contact
                        }

                        console.debug(dataElem);
                        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                        commonFunc.postMethod(url, dataElem).then((response) => {
                            var dataSave = response.data;
                            if (dataSave) {
                                if (dataSave.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: t("gal_success"),
                                        html: t("gal_success" + (isUpdate ? "Upd" : "Add")),
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        getListData();
                                    });

                                    //dataSave.result.idResponse = dataSave.result[secondaryKey];
                                    //resolve(dataSave.result);
                                    dataElem[secondaryKey] = dataSave.result;
                                    dataElem.idResponse = dataSave.result;
                                    resolve(dataElem);

                                    modalRoot.unmount();
                                }
                                else {
                                    var supErrors = "";
                                    if (dataSave.errors && dataSave.errors.length) {
                                        supErrors = dataSave.errors.map((error) => {
                                            return "<br>" + error.desc + "(" + error.value + ")";
                                        });
                                    }
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: t("gal_error" + (isUpdate ? "Upd" : "Add")) + " :<br>" + dataSave.errorMessage + supErrors,
                                        didOpen: () => { Swal.hideLoading() },
                                    });
                                    resolve(dataSave);
                                }
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    html: t("gal_error" + (isUpdate ? "Upd" : "Add")),
                                    didOpen: () => { Swal.hideLoading() },
                                });
                                resolve();
                            }
                        });
                    }
                    else {
                        if (!saveItem) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorCfg"),
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_invalidArgs")
                            });
                        }
                        modalRoot.unmount();
                        resolve();
                    }
                }
                else {
                    modalRoot.unmount();
                    resolve();
                }
            });
        };


        modelFctManager.onActionRequired(data.name, { trigger: "getModel", value: data.argumentsObj.dialogConfig }, data).then(actionResponse => {
            if (actionResponse.isSuccess) {
                var type = systemItem["@@PRIMARY_KEY@@"].subType;
                var subType = systemItem["@@SECONDARY_KEY@@"].subType;
                var genId = systemItem[primaryKey].defaultValue;

                var searchTag = (data.argumentsObj?.cSearchParams && data.argumentsObj?.cDialogSearch) ? (getValues(commonFunc.camelize(data.argumentsObj.cSearchParams, true)) || "") : "";
                var supProps = {
                    t: t, configModel: actionResponse.result, appProps: modelFctManager.appProps, checkRights: modelFctManager.checkRights, dataCfg: modelFctManager.dataCfg, getRoutes: modelFctManager.getRoutes,
                    genRef: modalGenManager, genId: genId, genType: type, subType: subType, itemData: data, noScroll: (data.argumentsObj.dialogNoScroll ? true : false), size: data.argumentsObj.dialogSize,
                    forcedCreate: forcedCreate, searchTag: searchTag, systemItem: systemItem, modelFctManager: modelFctManager, backdropMode: "static", callback: callbackModal
                };
                if (data.argumentsObj.noBackdrop) supProps.backdropMode = false;
                else if (data.argumentsObj.dlgBackdropClose) supProps.backdropMode = true;
                if (data.argumentsObj.dlgClickClose) supProps.clickClose = true;


                if (systemItem["@@URL_GET@@"] && idElem) {
                    getData(idElem).then((responseData) => {
                        if (responseData.isSuccess) {
                            currData = responseData.result;
                            modalRoot = createRoot(document.createElement('div'));
                            modalRoot.render(<SLGenModal dataElem={currData} title={(currData ? t(data.subType + "_updTitle") : t(data.subType + "_addTitle"))} {...supProps} />);
                        }
                    });
                }
                else {
                    modalRoot = createRoot(document.createElement('div'));
                    modalRoot.render(<SLGenModal dataElem={currData} title={(currData ? t(data.subType + "_updTitle") : t(data.subType + "_addTitle"))} {...supProps}  />);
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: actionResponse.errorMessage
                });
            }
        });
    }

    //TODO : Ajout arguments sur ReportItem pour :
    //validation (0, 1 >> validation classique, 2 >> validation par code)
    //permanent (suppression permanente ou non)
    function removeData(id, rowData) {
        return new Promise((resolve, reject) => {
            if (disabled) { resolve({ isSuccess: false, result: t("gal_disabledComponent") }); return; }
            var row = rowData;
            var title = "";
            if ((!id && row) || (id && row && id === row[secondaryKey])) {
                id = id || row[secondaryKey];
                title = (row.name || "") + " " + (row.firstName || "");
            }
            if (parseInt(id) > 0) {
                var removeItem = systemItem["@@URL_RMV@@"];
                if (removeItem && removeItem.argumentsObj && Object.keys(removeItem.argumentsObj).length) {
                    Swal.fire({
                        icon: "question",
                        title: t("gal_rmvTitle"),
                        html: t(data.subType + "_rmvTitle") + "<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: t("gal_yes"),
                        cancelButtonText: t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: t("gal_removing"),
                                didOpen: () => { Swal.showLoading() }
                            });
                            var args = { id: id };

                            Object.keys(removeItem.argumentsObj).forEach((key) => {
                                var valueArgs = removeItem.argumentsObj[key];
                                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                else args[key] = valueArgs;
                            });

                            var url = "../" + removeItem.argumentsObj.url;
                            commonFunc.postMethod(url, args).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    getListData();//TODO : check si besoin de refresh supplémentaire
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(data);
                            });

                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    if (!removeItem) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorCfg")
                        });
                        resolve({ isSuccess: false, result: t("gal_errorCfg") });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_invalidArgs")
                        });
                        resolve({ isSuccess: false, result: t("gal_invalidArgs") });
                    }
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidID")
                });
                resolve({ isSuccess: false, result: t("gal_invalidID") });
            }
        });
    }

    function showFlows(idElem, rowData) {
        if (disabled) { return; }
        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        if (parseInt(idElem) > 0) {
            //Traitement des informations retourné par le Dialog
            var callbackModal = function (dataElem, isUpdate) {
                modalRoot.unmount();
            };

            //setValue(secondaryKey, idElem);
            if (!systemItem[secondaryKey]) systemItem[secondaryKey] = {};
            systemItem[secondaryKey].defaultValue = idElem;

            modalRoot = createRoot(document.createElement('div'));
            modalRoot.render(<FlowsModal t={t} itemData={data} title={t(data.subType + "_flowsTitle")} idElem={idElem} rowData={rowData}
                parentContext={{ getData: getData, systemItem: systemItem, modelFctManager: modelFctManager, parentProps: parentProps }} callback={callbackModal} />);

        }
        else {
            Swal.fire({
                icon: "error",
                title: t("gal_error"),
                html: t("gal_invalidID")
            });
        }
    }

    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function datepickerChange(date) {
        if (!date) date = moment(curDate);

        setCurDate(date.format());
    }

    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }
    
    function getFormattedDate() {
        switch (curPeriod) {
            case "D": return moment(curDate).format("dddd DD MMMM YYYY");
            case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
            case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
            case "M": return moment(curDate).startOf('month').format("ddd DD MMMM YYYY") + " au " + moment(curDate).endOf('month').format("ddd DD MMMM YYYY");
            case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
            default: return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/


    //TODO : design
    var frameClass = "";
    //var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    //var widthClass = "";
    //var titleWidthClass = "px-0 ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_widgetList");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }
    }
    //if (!commonFunc.isBlank(widthClass) || titleWidthClass !== "px-0 ") containerClass += " row m-0 row-cols-lg-auto2 align-items-center";

    var rightsObj = systemItem["@@URL_SAVELIST@@"];
    var saveListRights = true;
    if (rightsObj && rightsObj.checkRights) {
        saveListRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem["@@URL_REMOVELIST@@"];
    var removeListRights = true;
    if (rightsObj && rightsObj.checkRights) {
        removeListRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem["@@URL_ADD@@"];
    var addRights = true;
    if (rightsObj && rightsObj.checkRights) {
        addRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }


    var lightMode = true;

    var onlyShowDialog = data.argumentsObj?.cOnlyShowDialog;

    var altConfigs = {};
    if (data.argumentsObj?.cPeriods) altConfigs.cPeriods = data.argumentsObj?.cPeriods;
    if (!data.argumentsObj?.cNoPeriods) altConfigs.updatePeriod = setCurPeriod;

    var baseForm = <>
        <div className="clearfix">
            {systemItem["@@URL_GETLIST@@"] && systemItem["@@URL_GETLIST@@"].argumentsObj && systemItem["@@URL_GETLIST@@"].argumentsObj.cUseToolbarDate ?
                <ToolbarDate refreshContent={getListData} customTitle={getFormattedDate()/*this.state.curDate.toLocaleString("fr-FR", { month: "long" })*/} hideRefresh={true}
                    currentPeriod={curPeriod}
                    selPreviousPeriod={selPreviousPeriod}
                    datepickerChange={datepickerChange}
                    selNextPeriod={selNextPeriod}
                    datepickerOpt={{ showWeeks: true, initialValue: moment(new Date()).utc().toDate() }}
                    customAddBtn={<div className="d-none"></div>} {...altConfigs}></ToolbarDate>
                : ""}

            <div className="float-start">
                {systemItem["@@URL_GETLIST@@"] && !(systemItem["@@URL_GETLIST@@"].argumentsObj && systemItem["@@URL_GETLIST@@"].argumentsObj.cHideButton) ?
                    (<Button className="btn-rotate px-2 mt-0 btn-simple" color="dark" size="sm" onClick={() => {
                        var getlistItem = systemItem["@@URL_GETLIST@@"];
                        if (getlistItem && getlistItem.argumentsObj && getlistItem.argumentsObj.useProp) {
                            modelFctManager.onActionRequired(data.name, { trigger: "refreshElem" }, data).then(actionResponse => {
                                if (actionResponse.isSuccess) {
                                    //getListData();
                                }
                                else {
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: actionResponse.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            getListData();
                        }
                    }}>
                        <i className="fa fa-sync"></i>{t(data.subType + "_refresh")}
                    </Button>)
                    : ""}
                {systemItem["@@URL_SAVELIST@@"] && saveListRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="primary" size="sm" onClick={() => { saveList() }}>
                    <i className="fa fa-save"></i>{t(data.subType + "_saveList")}
                </Button> : ""}
                {systemItem["@@URL_REMOVELIST@@"] && removeListRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="danger" size="sm" onClick={() => { removeList() }}>
                    <i className="fa fa-times"></i>{t(data.subType + "_removeList")}
                </Button> : ""}
                {systemItem["@@URL_ADD@@"] && addRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="success" size="sm" onClick={() => { saveData() }}>
                    <i className="fa fa-plus"></i>{t(data.subType + "_add")}
                </Button> : ""}
                <div className="d-inline-block" style={{ marginTop: "-10px", maxWidth:"950px" }}>
                    <div className="row m-0">
                        {data.children ? data.children.map((child) => {
                            return modelFctManager.componentTyped(child, parentProps);
                        }) : ""}
                    </div>
                </div>
            </div>
            {systemItem["@@URL_GETSTATUS@@"] && !(systemItem["@@URL_GETSTATUS@@"].argumentsObj && systemItem["@@URL_GETSTATUS@@"].argumentsObj.cHideButton) ? <CNavbar className="float-end">
                <div className="text-end">
                    {listStatus.map((dt) => {
                        var statusClass = "form-badge-radio mb-1 ";
                        statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                        return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                            <div className='form-check-radio fcheck-sm mb-0'>
                                <Label check >
                                    <Input id={`status_${dt.idStatus}`} name={"status"} /*disabled={this.state.editionMode}*/ checked={dt.idStatus === curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                        var value = parseInt(e.target.value);
                                        setCurStatus(value);
                                    }} />
                                    <span className="form-check-sign" />
                                    {(() => {
                                        var classFa = "";
                                        if (dt.css && dt.css.indexOf("fa-")) {
                                            dt.css.split(" ").forEach((classElem) => {
                                                //console.debug(classElem.startsWith("fa-") + classElem);
                                                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                            });
                                        }
                                        return <i className={`fa ${classFa} me-1`}></i>
                                    })()}
                                    {dt.name}
                                </Label>
                            </div>
                        </div> : "";
                    })}
                </div>
            </CNavbar> : ""}
            <div id={data.subType + "_select_filters"} className="d-none w-auto p-0">
                {data.options ? data.options.map((optionSelect, indexSelect) => {
                    return <>
                        <Label className={`px-0 m-0 d-inline-block me-2`} for={"select" + indexSelect}>{optionSelect.title}</Label>
                        <Input key={indexSelect} id={"select" + indexSelect} size="sm" className={`w-auto d-inline-block`} type="select" disabled={disabled} onChange={(e) => {
                            var selValue = e.target.value;
                            var getlistItem = systemItem["@@URL_GETLIST@@"];
                            if (getlistItem && getlistItem.argumentsObj && optionSelect.defaultValue) {
                                getlistItem.argumentsObj[optionSelect.defaultValue] = selValue;
                                getListData();
                            }
                            else {
                                curFilter[optionSelect.value] = selValue;
                                setCurFilter(curFilter);
                                setFilteredRows(filterData(curFilter));
                                setDataStamp(new Date().getTime());
                            }
                        }}>
                            {(() => {
                                var options = [{ selected: true, title: "Tous", value: -1 }];

                                if (optionSelect.options) {
                                    options = optionSelect.options;
                                }
                                /*else {
                                    //TODO : alimenter les options avec les data
                                    dataRows.forEach((row) => {
                                        var value = commonFunc.getValue(row, optionSelect.value);
                                        if (value) {
                                            options.push({ title: value, value: value });
                                        }
                                    });
                                }*/

                                return options.map((option, index) => {
                                    return <option className={`${option.hidden ? "d-none" : ""}`} key={index} selected={option.selected} value={option.value}>
                                        {option.customDesign && option.customDesign.design && option.customDesign.design.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                        {option.title}
                                    </option>
                                });
                            })()}
                        </Input>
                    </>
                }) : ""}
            </div>
        </div>
        <div className="clearfix d-flex">
            {data.argumentsObj.cSwitchWidget ?<div className="float-start flex-fill"><Button className="btn-icon btn-round" color="primary" onClick={() => {
                data.objType = "simpleList";
                data.key = 0;
                if (!data.onActionEvents) data.onActionEvents = {};
                data.onActionEvents.onLoad = (data.onActionEvents?.onLoad?.filter((event) => !(event.trigger === "updateDataStamp" && event.contextType === "autoDisplay")) || []);
                data.onActionEvents.onLoad.push({ trigger: "updateDataStamp", contextType: "autoDisplay" });
                parentProps?.parentData?.functionManager.rerender(true);
            }}><i className="fa fa-table" title={t("gal_switchDisplay")} ></i></Button></div> : ""}
            <div className="align-content-end">
                <div>{maxPages > 1 ? ("Page " + currentPage) + " - " : ""} {t("gal_results")} : {filteredRows.length}{dataCount > 0 ? " (" + dataCount + ")" : ""}</div>
            </div>
        </div>
        <div ref={widgetRef} className={`widget-container p-3`} style={lightMode ? { background: "#D3DFE4"} : {}} wdgt-id={"widgetGen" + data.subType} stamp={dataStamp}>
            {filteredRows.map((rowData, index) => {//TODO : gérer model ???
                //, overflowY: "auto", maxHeight: "52vh", height: "52vh" rgba(30, 89, 115, 0.9)

                var dateNoExclusion = (date, format) => {
                    var mDate = date ? commonFunc.restStringToDate(date) : null;
                    var formattedDate;
                    if (commonFunc.isValidDate(mDate) && mDate.getFullYear() > 1) {
                        formattedDate = commonFunc.isBlank(format) ? commonFunc.formatDateDMY(moment(mDate).utc(true).toDate()) : moment(mDate).utc(true).format(format);
                        return formattedDate;
                    }
                    else {
                        //Correctif order date désactiver à cause de présent de champ vide
                        if (!commonFunc.isValidDate(mDate)) mDate = "0001-01-01T00:00:00";
                        formattedDate = commonFunc.isBlank(format) ? commonFunc.formatDateDMY(moment(mDate).utc(true).toDate()) : moment(mDate).utc(true).format(format);
                        return "<div class='hidden'>" + formattedDate + "</div>";
                    }
                };

                var showAddSup = false;
                if (systemItem["@@URL_ADDSUP@@"]) {
                    if (systemItem["@@URL_ADDSUP@@"].argumentsObj && systemItem["@@URL_ADDSUP@@"].argumentsObj.cShowButton) {
                        var value = commonFunc.getValue(rowData, systemItem["@@URL_ADDSUP@@"].argumentsObj.cShowButton);
                        showAddSup = commonFunc.isBlank(value);
                    }
                    else {
                        showAddSup = true;
                    }
                }

                var rightsObj = systemItem["@@URL_ADDSUP@@"];
                if (showAddSup && rightsObj.checkRights) {
                    showAddSup = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                }
                rightsObj = systemItem["@@URL_UPD@@"];
                var updRights = true;
                if (rightsObj?.checkRights) {
                    updRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                }
                rightsObj = systemItem["@@URL_RMV@@"];
                var rmvRights = true;
                if (rightsObj?.checkRights) {
                    rmvRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                }
                rightsObj = systemItem["@@URL_FLOWS@@"];
                var flowsRights = true;
                if (rightsObj?.checkRights) {
                    flowsRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                }
                if (rightsObj?.argumentsObj?.cShowButton) {
                    var value2 = commonFunc.getValue(rowData, rightsObj.argumentsObj.cShowButton);
                    flowsRights &= !commonFunc.isBlank(value2);
                }



                var onClick = (e) => {
                    if (onlyShowDialog || (showAddSup || (updRights && rowData))) {
                        if (commonFunc.isBlank(window.getSelection().toString()) && (!e.target.classList.contains("fa-file-pdf") && !e.target.classList.contains("fa-clock-rotate-left") && !e.target.classList.contains("btn"))) {
                            if (data.onActionEvents && data.onActionEvents["onClick"]) {
                                data.onActionEvents["onClick"].forEach((args, index) => {
                                    if (args.value === "listValues") args.value = rowData;

                                    if (args.trigger === "manageData") {
                                        saveData(rowData[secondaryKey], rowData, showAddSup);
                                    }
                                    else {
                                        modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                                            //console.debug("RESPONSE");
                                            //console.debug(actionResponse);
                                            if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: t("gal_error"),
                                                    html: actionResponse.errorMessage
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                };


                //entityFiles
                return (<Card key={"gen" + index} className={`mt-2 col-xl-8 widget-magnify overflow-hidden ${lightMode ? "" : "text-light"}`} style={lightMode ? { minHeight: "192px", maxHeight:"192px" } : { background: "rgba(30, 89, 115, 0.95)" }} onClick={onClick}>
                    <CardHeader className="p-0">
                        <div className="d-flex">
                            <div class="text-center ms-2 mt-1 d-none2">
                                <img className="ui-icon-64 ui-icon-row2 rounded float-start" src="../api/data/DownloadFileByUri?fileId=352&amp;fileName=20231117075304_logo-exaris.svg&amp;accessToken=iUX0XWgQ1YhZ3GLtKgvgYCrznqUBUe3lZIlCnztsyWpTZeTPvPTLquTIlB6ibuPkICS8eWZz0sCAAIlWFARnDWk7Y2r9Z8PMn92cBmMwwPPmVYh92a9uWmXEvolBLQ%2b3MdOfepbRSGTVuXAwIGGvvl8J%2b8i48Ve%2bDGXS%2bYAJTJsNePb5u4ZMGc93IcjqmJlitUrotUeUr2H28KAS7RamYPbfUncRd4myzb9AvsGqazdKHvEc1JhyJ3LUtzzGlqMlQGHdCeTTtS8NwsTCDQUNnwLZaLXGZn4hKOxM%2bMAXZKoaNiR%2b3rCY9fHs55ViA4dmuftRMnpxpQf6vkroEywvSE6%2bURhechS9tO5Q45u4T%2frjJrT0hv1T664GwLHxNgqszMtgP8jAqJ6IkuBqS%2f8T1DMukUa92K%2fjhBdCKAUHF%2bY%3d&amp;newWindow=false" alt="Avatar" />
                            </div>
                            <div className="flex-fill w-75 ps-3 pt-3">
                                <div className="text-truncate w-50 d-none" style={{ fontSize: "10px" }}>{(commonFunc.isBlank(rowData.fichier_pdf) || (rowData.fichier_pdf?.endsWith && rowData.fichier_pdf.endsWith("&fileName="))) ? rowData.lien_pdf : rowData.fichier_pdf}</div>
                                <CardTitle tag="h6" className={`m-0 text-truncate2 line2-ellipsis w-75 searchParams ${lightMode ? "" : "text-light"}`} title={rowData.titre}>{rowData.titre}</CardTitle>
                                {(systemItem["@@URL_RMV@@"] && rmvRights) ? <Button className='btn-icon m-0 me-2' disabled={disabled} color="danger" size="sm"
                                    onClick={() => removeData(rowData[secondaryKey], rowData)} title={t("gal_remove")}><i className='fa fa-trash-alt'></i></Button> : ""}
                                {(systemItem["@@URL_FLOWS@@"] && flowsRights) ? <Button className='btn-simple btn-icon m-0' disabled={disabled} color="dark" size="sm"
                                    onClick={() => showFlows(rowData[secondaryKey], rowData)} title={t("gal_flows")}><i className='fa fa-clock-rotate-left'></i></Button> : ""}
                            </div>
                            <div className="flex-fill pe-3 pt-3">
                                <Progress className="w-100" title={rowData.score} color={commonFunc.createProgressBar((rowData.score * 2))} style={{ height: '15px', position: "relative", zIndex: 2 }} value={(rowData.score * 2)}></Progress>
                            </div>
                        </div>
                        <div className="widget-tools collapse-tool">
                            <div data-name="GroupFrag" data-element="group" className=" p-0 col-auto">
                                <div className="row" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                    <div data-name="TextViewFrag" data-element="textview" className="d-inline-block mb-3 p-0 col-auto">
                                        <div className="  m-0 row-cols-lg-auto2 align-items-center form-group m-0 "><i className={`fa fa-wheat-awn-circle-exclamation ${((systemItem["@@URL_FLOWS@@"] && flowsRights)) ? "text-success" : ""}`} style={{ marginTop: "25px", color: (lightMode ? "rgb(120, 120, 120)" : "rgb(255, 255, 255)"), fontSize: "65px" }}></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardHeader>
                    <CardBody className="pt-2">
                        <div className="d-flex">
                            <div className="pe-2 fw-bold text-secondary">{dateNoExclusion(rowData.date_publication, "DD MMMM YYYY")}</div>
                            <div className="pe-2">{/*Chrono - Type*/rowData.chrono} - {rowData.categ} {rowData.stype}</div>
                            <div className="text-decoration-underline text-truncate" style={{ maxWidth: "55%" }} title={rowData.reference}>Réf : {rowData.reference}</div>
                            {(commonFunc.isBlank(rowData.fichier_pdf) || (rowData.fichier_pdf?.endsWith && rowData.fichier_pdf.endsWith("&fileName="))) ? <div class="text-center ms-2" style={{}}>
                                <a target="_blank" href={rowData.lien_pdf}><i class={`fa fa-file-pdf fa-lg ${lightMode ? "" : "text-light"}`}></i></a>
                            </div> : <div class="text-center ms-2">
                                <a target="_blank" href={rowData.fichier_pdf}><i class={`fa fa-file-pdf fa-lg ${lightMode ? "" : "text-light"}`}></i></a>
                            </div>}
                            <div className="flex-fill"></div>
                        </div>
                        <div className="mt-1 searchParams line3-ellipsis fst-italic" style={{ fontSize: "14px" }} title={rowData.exaris}>{rowData.exaris}</div>
                    </CardBody>
                </Card>);
            })}
        </div>
        <div className="clearfix d-flex">
            <div className="flex-fill text-end">
                {(() => {
                    var pagesList = [];
                    if (maxPages > 1) {
                        pagesList.push(1);
                        var currChildCount = 1;
                        var countPage = 3;
                        var currCountPage = 3;
                        var appendEnd = false;
                        var minPage = (currentPage - (countPage - currChildCount)) > 1 ? (currentPage - (countPage - currChildCount)) : 2;
                        if (minPage > 2 && maxPages > countPage + (currChildCount + 1)) {
                            pagesList.push("...");
                            currCountPage--;
                            minPage++;
                        }
                        if (minPage > (maxPages - countPage - 1) && (maxPages - ((currChildCount * 2) + 2)) > 0) minPage = (maxPages - ((currChildCount * 2) + 2));
                        if (minPage <= 1) minPage = 2;
                        if (minPage <= maxPages) {
                            var currMaxPage;
                            if ((minPage + countPage + 2) > maxPages) {
                                currMaxPage = (maxPages > 2 ? maxPages - 1 : maxPages);
                            }
                            else {
                                currMaxPage = (minPage + currCountPage);
                                currCountPage--;
                                appendEnd = true;
                            }
                            for (var i = minPage; i <= currMaxPage; i++) {
                                pagesList.push(i);
                            }
                            if (appendEnd) pagesList.push("...");
                        }
                        if (maxPages > currMaxPage) pagesList.push(maxPages);
                    }

                    return pagesList.length ? <>
                        <Button className={`btn-icon btn-round ${(currentPage - 1) < 1 ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { setCurrentPage(currentPage - 1, true); }}><i className="fa fa-chevron-left"></i></Button>
                        {pagesList.map(i => <Button className={`btn-icon btn-round ${i === "..." ? "disabled" : ""}`} size="sm" color={i === currentPage ? "primary" : "secondary"} onClick={(e) => { setCurrentPage(i, true); }}>{i}</Button>)}
                        <Button className={`btn-icon btn-round ${(currentPage + 1) > maxPages ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { setCurrentPage(currentPage + 1, true); }}><i className="fa fa-chevron-right"></i></Button>
                    </> : "";
                })()}
                <div>{t("gal_results")} : {filteredRows.length}</div>
            </div>
        </div>

    </>;


    if (data.argumentsObj.sidebarMini) document.body.classList.add("sidebar-mini");
    if (data.argumentsObj.sidebarLocked) document.body.classList.add("sidebar-locked");

    /*
    <Card key={"gen" + index} className="text-light mt-2 widget-magnify" style={{ background: "rgba(30, 89, 115, 0.9)" }}>
                    <CardHeader className="p-0">
                        <div className="d-flex">
                            {(commonFunc.isBlank(elem.fichier_pdf) || (elem.fichier_pdf?.endsWith && elem.fichier_pdf.endsWith("&fileName="))) ? <div class="text-center ms-3 mt-3">
                                <a target="_blank" href={elem.lien_pdf}><i class="fa fa-file-pdf fa-2x text-light"></i></a>
                            </div> : <div class="text-center ms-3 mt-3">
                                <a target="_blank" href={elem.fichier_pdf}><i class="fa fa-file-pdf fa-2x text-light"></i></a>
                            </div>}
                            <div className="flex-fill w-75 ps-2 pt-3" onClick={onClick}>
                                <div className="text-truncate w-50" style={{ fontSize: "10px" }}>{(commonFunc.isBlank(elem.fichier_pdf) || (elem.fichier_pdf?.endsWith && elem.fichier_pdf.endsWith("&fileName="))) ? elem.lien_pdf : elem.fichier_pdf}</div>
                                <CardTitle tag="h6" className="m-0 text-light text-truncate w-75">{elem.titre}</CardTitle>
                            </div>
                            <div className="flex-fill pe-3 pt-3" onClick={onClick}>
                                    <Progress className="w-100" color={commonFunc.createProgressBar((elem.score * 2))} style={{ height: '15px' }} value={(elem.score * 2)}></Progress>
                                </div>
                        </div>
                        <div className="widget-tools collapse-tool">
                            <div data-name="GroupFrag" data-element="group" className=" p-0 col-auto">
                                <div className="row" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                    <div data-name="TextViewFrag" data-element="textview" className="d-inline-block mb-3 p-0 col-auto">
                                        <div className="  m-0 row-cols-lg-auto2 align-items-center form-group m-0 "><i className="fa fa-wheat-awn-circle-exclamation" style={{ marginTop: "25px", color: "rgb(255, 255, 255)", fontSize: "65px" }}></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardHeader>
                    <CardBody className="pt-2" onClick={onClick}>
                        <div className="d-flex">
                            <div className="me-2">{dateNoExclusion(elem.date_publication, "DD MMMM YYYY")}</div>
                            <div className="me-2">{elem.chrono} - {elem.categ} {elem.stype}</div>
                            <div>Référence : {elem.reference}</div>
                        </div>
                        <div className="searchParams text-truncate" style={{ fontSize: "10px" }}>{elem.exaris}</div>
                    </CardBody>
                </Card>
    */



    return <Col xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`}>{baseForm}</Col>;//align-self-center
}


function SLGenModal({ t, title, configModel, dataCfg, appProps, checkRights, getRoutes, genRef, genId, genType, subType, itemData, noScroll, size, dataElem, forcedCreate, searchTag, systemItem, modelFctManager, backdropMode, clickClose, callback }) {
    //Vérification de droits spécifiques à l'affichage des boutons dialog
    var rightsObj = systemItem["@@URL_DLGADD@@"];
    var addRights = true;
    if (rightsObj?.checkRights) {
        addRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem["@@URL_DLGUPD@@"];
    var updRights = true;
    if (rightsObj?.checkRights) {
        updRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }

    var supProps = {};
    if (clickClose) supProps.onClick = (e) => { console.debug(e.target.nodeName); if (e.target.nodeName !== "BUTTON" && e.target.parentElement.nodeName !== "BUTTON") callback(); };

    return (
        <Modal isOpen={true} className={`modal-${itemData.subType} ${noScroll ? "modal-noscroll" : ""}`} size={size ? size : "xxl"} scrollable keyboard={false} toggle={() => { callback(); }}
            backdrop={backdropMode} style={{ paddingTop: "0px" }} {...supProps}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={noScroll ? { overflow: "visible" } : { overflowX: "hidden" }}>
                <AGenerateModel ref={genRef} noButtons onSubmit={(data, isUpdate) => callback(data, isUpdate)} appProps={appProps} checkRights={checkRights} getRoutes={getRoutes} parentProps={{ id: genId, type: genType, subType: subType, dataCfg: dataCfg }} keyMode={2} configModel={configModel} loadedData={dataElem} searchTag={searchTag} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {
                    (dataElem && !forcedCreate) ? <Button className={`px-3 ${addRights ? "" : "d-none"}`} color="primary" onClick={() => {
                        var generateModel = genRef.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>{t("gal_edit")}</Button> : <Button className={`px-3 ${updRights ? "" : "d-none"}`} color="success" onClick={() => {
                        var generateModel = genRef.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                        }}><i className="fa fa-plus"></i>{t("gal_add")}</Button>
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_close")}</Button>
            </ModalFooter>
        </Modal>
    );
}

function FlowsModal({ t, title, itemData, noScroll, idElem, rowData, dataFlows, parentContext, callback }) {

    const [flows, setFlows] = React.useState(dataFlows || []);

    var flowsItem = parentContext.systemItem["@@URL_FLOWS@@"];

    React.useEffect(() => {
        if (!flowsItem.argumentsObj.componentUrl) {
            initFlows();
        }
    }, []);

    function initFlows() {
        var currData = rowData;

        var args = {};
        if (flowsItem && flowsItem.argumentsObj && Object.keys(flowsItem.argumentsObj).length && flowsItem.argumentsObj.url) {
            Object.keys(flowsItem.argumentsObj).forEach((key) => {
                var valueArgs = flowsItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (parentContext.systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + flowsItem.argumentsObj.url;
            commonFunc.getMethod(url, args).then((response) => {

                if (response.data) {
                    if (response.data.isSuccess) {

                        Swal.close();


                        setFlows(response.data.result);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(itemData.subType + "_errorGet") + " :<br>" + response.data.errorMessage
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t(itemData.subType + "_errorGet")
                    });
                }
            });
        }
        else if (parentContext.systemItem["@@URL_GET@@"] && idElem) {
            parentContext.getData(idElem).then((responseData) => {
                if (responseData.isSuccess) {
                    currData = responseData.result;

                    if (Array.isArray(currData)) {
                        setFlows(currData);
                    }
                    else {
                        setFlows(currData.flows);
                    }
                }
            });
        }
        else if (currData.flows) {
            if (Array.isArray(currData)) {
                setFlows(currData);
            }
            else {
                setFlows(currData.flows);
            }
        }
        else {
            if (!flowsItem) {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_errorCfg")
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    return (
        <Modal isOpen={true} className={`modal-flows ${noScroll ? "modal-noscroll" : ""}`} size="xxl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <Historical type="modelFlows" elemId={idElem} rows={flows} url={flowsItem.argumentsObj.componentUrl ? "../" + flowsItem.argumentsObj.componentUrl : ""} getRoutes={parentContext.modelFctManager.getRoutes} shouldRender={true}>
                    {flowsItem.children ? flowsItem.children.map((child) => {
                        return parentContext.modelFctManager.componentTyped(child, parentContext.parentProps);
                    }) : ""}
                </Historical>
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}